module.exports = __webpack_public_path__ + "static/media/4656.8543c882.jpg";